import { Component, input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IonIconDirective } from '../../../../../../libs/common/directives/src/ion-icon/ion-icon.directive';

@Component({
  selector: 'app-widget-button',
  templateUrl: './widget-button.component.html',
  styleUrls: ['./widget-button.component.scss'],
  imports: [IonicModule, IonIconDirective],
})
export class WidgetButtonComponent {
  icon = input.required<string>();
  href = input.required<string>();
}
